module.exports = ".col-buttons {\n  text-align: end; }\n\n@media only screen and (max-width: 768px) {\n  .col-buttons {\n    text-align: start; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/corte-caja/realizar-corte-caja/realizar-corte-caja.component.scss
// module id = ./src/app/corte-caja/realizar-corte-caja/realizar-corte-caja.component.scss
// module chunks = main